import { createContext, useReducer } from 'react';
import selecetedShopIdReducer, {
  SelecetedShopIdReducerAction,
  selecetedShopIdReducerInitialState,
  SelecetedShopIdReducerState,
} from '../../../redusers/selected-shop-id-reducer';
import giftcardReducer, {
  GiftcardReducerAction,
  giftcardReducerInitialState,
  GiftcardReducerState,
} from '../../../redusers/giftcardReducer';
import currentStepReducer, {
  CurrentStepReducerAction,
  currentStepReducerInitialState,
  CurrentStepReducerState,
} from '../../../redusers/current-step-reducer';
import paymentReducer, {
  PaymentReducerAction,
  paymentReducerinitialState,
  PaymentReducerState,
} from '../../../redusers/payment-reducer';
import vouchersReducer, {
  VouchersReducerAction,
  vouchersReducerInitialState,
  VouchersReducerState,
} from '../../../redusers/vouchers-reducer';
import customerReducer, {
  CustomerReducerAction,
  customerReducerInitialState,
  CustomerReducerState,
} from '../../../redusers/customer-reducer';
import recipientReducer, {
  RecipientReducerAction,
  recipientReducerInitialState,
  RecipientReducerState,
} from '../../../redusers/recipient-reducer';
import termsReducer, {
  TermsReducerAction,
  termsReducerInitialState,
  TermsReducerState,
} from '../../../redusers/terms-reducer';
import errorReducer, {
  ErrorReducerAction,
  errorReducerinitialState,
  ErrorReducerState,
} from '../../../redusers/error-reducer';
import voucherReducer, {
  VoucherReducerAction,
  voucherReducerInitialState,
  VoucherReducerState,
} from '../../../redusers/voucher-reducer';
import loadingReducer, {
  LoadingReducerAction,
  loadingReducerInitialState,
  LoadingReducerState,
} from '../../../redusers/loading-reducer';
import isSummaryOpenReducer, {
  IsSummaryOpenAction,
  isSummaryOpenReducerInitialState,
  IsSummaryOpenState,
} from '../../../redusers/is-summary-open-reducer';
import giftcardCustomAmountReducer, {
  GiftcardCustomAmountReducerAction,
  giftcardCustomAmountReducerInitialState,
  GiftcardCustomAmountReducerState,
} from '../../../redusers/giftcard-custom-amount-reducer';
import createCombinedStateReducer from '../../../Utils/create-combined-state-reducer';

export type GiftcardStateAction =
  | SelecetedShopIdReducerAction
  | CurrentStepReducerAction
  | GiftcardReducerAction
  | GiftcardCustomAmountReducerAction
  | CustomerReducerAction
  | RecipientReducerAction
  | PaymentReducerAction
  | VoucherReducerAction
  | VouchersReducerAction
  | TermsReducerAction
  | IsSummaryOpenAction
  | LoadingReducerAction
  | ErrorReducerAction;

export interface GiftcardStateCombinedState {
  state: {
    selectedShopId: SelecetedShopIdReducerState;
    currentStep: CurrentStepReducerState;
    giftcard: GiftcardReducerState;
    customAmount: GiftcardCustomAmountReducerState;
    customer: CustomerReducerState;
    recipient: RecipientReducerState;
    payment: PaymentReducerState;
    voucher: VoucherReducerState;
    vouchers: VouchersReducerState;
    terms: TermsReducerState;
    isSummaryOpen: IsSummaryOpenState;
    loading: LoadingReducerState;
    errors: ErrorReducerState;
  };
  dispatch: React.Dispatch<GiftcardStateAction>;
}

const giftcardStateInitialState: GiftcardStateCombinedState = {
  state: {
    selectedShopId: selecetedShopIdReducerInitialState,
    currentStep: currentStepReducerInitialState,
    giftcard: giftcardReducerInitialState,
    customAmount: giftcardCustomAmountReducerInitialState,
    customer: customerReducerInitialState,
    recipient: recipientReducerInitialState,
    payment: paymentReducerinitialState,
    voucher: voucherReducerInitialState,
    vouchers: vouchersReducerInitialState,
    terms: termsReducerInitialState,
    isSummaryOpen: isSummaryOpenReducerInitialState,
    loading: loadingReducerInitialState,
    errors: errorReducerinitialState,
  },
  dispatch: () => {},
};

export const giftcardState = createContext(giftcardStateInitialState);

const giftcardStateReducers = {
  selectedShopId: selecetedShopIdReducer,
  currentStep: currentStepReducer,
  giftcard: giftcardReducer,
  customAmount: giftcardCustomAmountReducer,
  customer: customerReducer,
  recipient: recipientReducer,
  payment: paymentReducer,
  voucher: voucherReducer,
  vouchers: vouchersReducer,
  terms: termsReducer,
  isSummaryOpen: isSummaryOpenReducer,
  loading: loadingReducer,
  errors: errorReducer,
};

interface GiftcardStateProviderProps {
  children: React.ReactNode;
}

const GiftcardStateProvider = (props: GiftcardStateProviderProps) => {
  const giftcardStateReducer = createCombinedStateReducer(giftcardStateReducers);

  const [state, dispatch] = useReducer(
    giftcardStateReducer,
    giftcardStateInitialState.state
  );

  return (
    <giftcardState.Provider value={{ state, dispatch }}>
      {props.children}
    </giftcardState.Provider>
  );
};

export default GiftcardStateProvider;
